export default [
  '1-3',
  '3-6',
  '6-10',
  '10-18',
  '18-30',
  '30-50',
  '50-80',
  '80-120',
  '120-180',
  '180-250',
];
